import { useEffect, useState } from 'react';
import './App.css';
import logo from './images/logo.jpeg';

function App() {
  const [language, setLanguage] = useState('FI');
  const [storySlides, setStorySlides] = useState({ 0: 0, 1: 0, 2: 0 });
  const [reviewSlides, setReviewSlides] = useState({ first: 0, second: 0 });

  // Booking platform link
  const bookingLink = "https://timma.fi/yritys/ari-parturi-kampaamo?isSearch=true";
  const instagramLink = "https://www.instagram.com/hairstylist.arii/";

  // Translations
  const translations = {
    ENG: {
      nav: {
        about: "About",
        services: "Services",
        stories: "Stories",
        book: "Book an Appointment"
      },
      hero: {
        text: "Experience expert hairstyling with personalized care. Transform your look with our professional services.",
        button: "Book an Appointment"
      },
      intro: {
        text: "Your hair deserves expert care. At Ari Parturi&Kampaamo, we create looks that celebrate your unique style. Let's transform your hair into something beautiful.",
        link: "Our Services",
        reviewsTitle: "Customer Reviews",
        reviewsLead: "What our clients say about their experience"
      },
      services: {
        title: "Our Services",
        haircuts: {
          title: "Haircuts",
          description: "Professional cuts tailored to your style and face shape"
        },
        coloring: {
          title: "Coloring",
          description: "Expert color services including highlights, balayage, and full color"
        },
        styling: {
          title: "Styling",
          description: "Special occasion styling and blowouts"
        },
        treatments: {
          title: "Treatments",
          description: "Deep conditioning and hair care treatments"
        }
      },
      about: {
        label: "About the Founder",
        name: "Ari",
        description: "With years of experience in the beauty industry, Ari brings passion and expertise to every client. Specializing in modern techniques and personalized service, we create looks that enhance your natural beauty and reflect your unique style.",
        link: "Check out Ari's Instagram"
      },
      stories: {
        title: "Hair Stories",
        story1: {
          title: "Modern Transformation",
          description: "See how we transformed a classic look into something modern and fresh."
        },
        story2: {
          title: "Color Makeover",
          description: "Discover the journey of a complete color transformation."
        },
        story3: {
          title: "Special Event Styling",
          description: "Creating the perfect look for your special day."
        },
        //link: "Read their story"
      },
      footer: {
        visit: "Visit Us",
        rights: "All rights reserved."
      }
    },
    FI: {
      nav: {
        about: "Tietoa",
        services: "Palvelut",
        stories: "Tarinat",
        book: "Varaa aika"
      },
      hero: {
        text: "Koe asiantunteva hiustenleikkuu henkilökohtaisella hoidolla. Muunna ilmeesi ammattimaisilla palveluillamme.",
        button: "Varaa aika"
      },
      intro: {
        text: "Hiuksesi ansaitsevat asiantuntevaa hoitoa. Ari Parturi&Kampaamossa luomme ilmeitä, jotka juhlistavat ainutlaatuista tyyliäsi. Muunnetaan hiuksesi joksikin kauniiksi.",
        link: "Palvelumme",
        reviewsTitle: "Asiakaspalautteet",
        reviewsLead: "Mitä asiakkaamme kertovat kokemuksestaan"
      },
      services: {
        title: "Palvelumme",
        haircuts: {
          title: "Hiustenleikkuu",
          description: "Ammattimaiset leikkaukset räätälöitynä tyylisi ja kasvonmuotosi mukaan"
        },
        coloring: {
          title: "Värjäys",
          description: "Asiantuntevat värjäyspalvelut, mukaan lukien raitoja, balayage ja täysi värjäys"
        },
        styling: {
          title: "Tyylittely",
          description: "Juhlatyylittely ja puhallukset"
        },
        treatments: {
          title: "Hoidot",
          description: "Syväkonditointi ja hiustenhoitohoidot"
        }
      },
      about: {
        label: "Perustajasta",
        name: "Ari",
        description: "Vuosien kokemuksella kauneusalalla Ari tuo intohimoa ja asiantuntemusta jokaiselle asiakkaalle. Erikoistuen moderneihin tekniikoihin ja henkilökohtaiseen palveluun, luomme ilmeitä, jotka korostavat luonnollista kauneuttasi ja heijastavat ainutlaatuista tyyliäsi.",
        link: "Katso Arin Instagram"
      },
      stories: {
        title: "Hiustarinat",
        story1: {
          title: "Muutosleikkaus",
          description: "Katso, miten muunnimme klassisen ilmeen moderniksi ja raikkaaksi."
        },
        story2: {
          title: "Värin muutos",
          description: "Löydä matka täydelliseen värin muutokseen."
        },
        story3: {
          title: "Juhlatyylittely",
          description: "Luomassa täydellistä ilmeitä erityispäivääsi varten."
        },
        //link: "Lue tarina"
      },
      footer: {
        visit: "Vieraile meillä",
        rights: "Kaikki oikeudet pidätetään."
      }
    }
  };

  const t = translations[language];

  const services = [
    {
      title: t.services.haircuts.title,
      description: t.services.haircuts.description,
      image: "/images/cutting.jpg"
    },
    {
      title: t.services.coloring.title,
      description: t.services.coloring.description,
      image: "/images/coloring.jpg"
    },
    {
      title: t.services.styling.title,
      description: t.services.styling.description,
      image: "/images/styling.jpg"
    },
    {
      title: t.services.treatments.title,
      description: t.services.treatments.description,
      image: "/images/s1.jpg"
    }
  ];

  const stories = [
    {
      title: t.stories.story1.title,
      description: t.stories.story1.description
    },
    {
      title: t.stories.story2.title,
      description: t.stories.story2.description
    },
    {
      title: t.stories.story3.title,
      description: t.stories.story3.description
    }
  ];

  const storyImages = [
    [
      "/images/muuto1.jpg",
      "/images/muuto2.jpg",
      "/images/muuto3.jpg",
      "/images/muuto4.jpg",
      "/images/muuto5.jpg",
      "/images/muuto6.jpg",
      "/images/muuto7.jpg",
      "/images/muuto8.jpg",
      "/images/muuto9.jpg"
    ],
    ["/images/color1.jpg", "/images/color2.jpg", "/images/color3.jpg", "/images/color4.jpg"],
    ["/images/juhla1.jpg", "/images/juhla2.jpg", "/images/juhla3.jpg"]
  ];

  const reviews = [
    {
      name: "Claudia Cervantes",
      comment: "Olen hiusten käsittelyssä erittäin vaativa asiakas, ja juuri siksi voin lämpimästi suositella tätä kampaamoa. Hiustenleikkaus oli tarkka ja viimeistelty. Ari kuunteli huolellisesti toiveitani ja leikkasi hiukseni täsmälleen niin kuin pyysin."
    },
    {
      name: "Riikka Leppinen",
      comment: "Ari teki sen, mistä muut on tähän asti kieltäytyneet - yhdellä käynnillä tummasta vaaleaksi. Suosittelen tällaiseen aloitus ajaksi viikonloppu aamua ilman muita suunnitelmia sille päivälle."
    },
    {
      name: "Mr. Bilk Haararoust",
      comment: "Loistavaa kiireetöntä palvelua! Ja parturit taitavimmasta päästä! Käynyt nyt vuoden ajan pelkästään täällä, ja joka kerta tyytyväinen tulokseen!"
    },
    {
      name: "Tiina Cagle",
      comment: "Paras kampaamo Ylöjärvellä. Eikä ole hinnalla pilattu. Jo kolmas kerta kun kampausta kohennettu ja tästä tulee kyllä täysin vakkaripaikka."
    },
    {
      name: "Maarit Aho",
      comment: "Erittäin hyvä ja ystävällinen asiakaspalvelu. Ari on taitava hiusten värjäyksessä ja tekee sen tunnollisesti aikaa säästämättä. Mukava tunnelma ja siistit tilat."
    },
    {
      name: "Thorsten Aho",
      comment: "Hyvä parturi, jossa on ammattilaisia leikkaajia. Ari antaa paljon herkkuja ja hän on ystävällinen. Suosittelen kaikille Arin kampaamoa!"
    },
    {
      name: "Merja Sihvonen",
      comment: "Loistavaa työtä Arilla, erittäin pätevä parturi/kampaaja. Olen todella tyytyväinen. Suosittelen."
    },
    {
      name: "Saara Helminen",
      comment: "Poika 12v oli sitä mieltä, että paras parturi, jossa hän on käynyt."
    },
    {
      name: "Katja Marika",
      comment: "Huikee meininki ja palvelu sekä mieletön ammattitaito!"
    },
    {
      name: "Abdullah",
      comment: "Todella hieno paikka ja erittäin hyvä asiakaspalvelu."
    },
    {
      name: "Jeena Aho",
      comment: "Hyvä asiakaspalvelu, erittäin hyvin leikkasivat poikien hiukset."
    },
    {
      name: "Matias Peltomäki",
      comment: "5/5 hyvä asiakas palvelua, hauska, leikkaa tosi hyvin."
    },
    {
      name: "Carita Neuvonen",
      comment: "Loistava kampaamo ja parturi. Ammattitaitoinen ja loistava asiakaspalvelu."
    }
  ];

  const firstReviewTrack = reviews.filter((_, index) => index % 2 === 0);
  const secondReviewTrack = reviews.filter((_, index) => index % 2 === 1);

  const changeStorySlide = (storyIndex, direction) => {
    setStorySlides((prev) => {
      const totalSlides = storyImages[storyIndex].length;
      const nextIndex = (prev[storyIndex] + direction + totalSlides) % totalSlides;
      return { ...prev, [storyIndex]: nextIndex };
    });
  };

  const changeReviewSlide = (track, direction) => {
    setReviewSlides((prev) => {
      const trackLength = track === 'first' ? firstReviewTrack.length : secondReviewTrack.length;
      return {
        ...prev,
        [track]: (prev[track] + direction + trackLength) % trackLength
      };
    });
  };

  useEffect(() => {
    const firstTimer = setInterval(() => {
      setReviewSlides((prev) => ({
        ...prev,
        first: (prev.first + 1) % firstReviewTrack.length
      }));
    }, 5000);

    const secondTimer = setInterval(() => {
      setReviewSlides((prev) => ({
        ...prev,
        second: (prev.second + 1) % secondReviewTrack.length
      }));
    }, 6200);

    return () => {
      clearInterval(firstTimer);
      clearInterval(secondTimer);
    };
  }, [firstReviewTrack.length, secondReviewTrack.length]);

  return (
    <div className="App">
      {/* Navigation */}
      <nav className="navbar">
        <div className="nav-container">
          <div className="logo">
            <img src={logo} alt="Ari logo" className="logo-image" />
            <span>Ari Parturi&Kampaamo</span>
          </div>
          <div className="nav-links">
            <a href="#about">{t.nav.about}</a>
            <a href="#services">{t.nav.services}</a>
            <a href="#stories">{t.nav.stories}</a>
            <button
              className="language-switch"
              onClick={() => setLanguage(language === 'ENG' ? 'FI' : 'ENG')}
            >
              {language === 'ENG' ? 'FI' : 'ENG'}
            </button>
            <div className="nav-cta-group">
              <a href={bookingLink} target="_blank" rel="noopener noreferrer" className="book-btn-nav">
                {t.nav.book}
              </a>
              <a
                href={instagramLink}
                target="_blank"
                rel="noopener noreferrer"
                className="instagram-link"
                aria-label="Instagram"
              >
                <svg viewBox="0 0 24 24" aria-hidden="true">
                  <path d="M7.75 2h8.5A5.75 5.75 0 0 1 22 7.75v8.5A5.75 5.75 0 0 1 16.25 22h-8.5A5.75 5.75 0 0 1 2 16.25v-8.5A5.75 5.75 0 0 1 7.75 2Zm0 1.5A4.25 4.25 0 0 0 3.5 7.75v8.5a4.25 4.25 0 0 0 4.25 4.25h8.5a4.25 4.25 0 0 0 4.25-4.25v-8.5a4.25 4.25 0 0 0-4.25-4.25h-8.5ZM17.5 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2ZM12 7a5 5 0 1 1 0 10 5 5 0 0 1 0-10Zm0 1.5A3.5 3.5 0 1 0 12 15.5 3.5 3.5 0 0 0 12 8.5Z" />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section with Image Area */}
      <section id="home" className="hero">
        <div className="hero-image-area">
          {/* Change the number (2, 3, or 4) to try different images */}
          <img src="/images/4.jpg" alt="Ari Parturi&Kampaamo" className="hero-image" />
          <div className="hero-overlay">
            <div className="hero-content-overlay">
              <p className="hero-info-text">
                {t.hero.text}
              </p>
              <a
                href={bookingLink}
                target="_blank"
                rel="noopener noreferrer"
                className="hero-book-button"
              >
                {t.hero.button}
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Intro Section */}
      <section className="intro">
        <div className="intro-content">
          <p className="intro-text">
            {t.intro.text}
          </p>
          <a href="#services" className="intro-link">{t.intro.link}</a>


        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="services">
        <div className="container">
          <h2 className="section-title">{t.services.title}</h2>
          <div className="services-grid">
            {services.map((service, index) => (
              <div key={index} className="service-card">
                <div className="service-card-image">
                  <img src={service.image} alt={service.title} onError={(e) => { console.error('Image failed to load:', service.image); }} />
                </div>
                <h3 className="service-card-title">{service.title}</h3>
                <p className="service-card-description">{service.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="about">
        <div className="container">
          <div className="about-content">
            <div className="about-text">
              <h3 className="about-label">{t.about.label}</h3>
              <h2 className="about-name">{t.about.name}</h2>
              <p className="about-description">
                {t.about.description}
              </p>
              <div className="about-contact-links">
                <a
                  href={instagramLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="about-link"
                  aria-label={t.about.link}
                >
                  <svg viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M7.75 2h8.5A5.75 5.75 0 0 1 22 7.75v8.5A5.75 5.75 0 0 1 16.25 22h-8.5A5.75 5.75 0 0 1 2 16.25v-8.5A5.75 5.75 0 0 1 7.75 2Zm0 1.5A4.25 4.25 0 0 0 3.5 7.75v8.5a4.25 4.25 0 0 0 4.25 4.25h8.5a4.25 4.25 0 0 0 4.25-4.25v-8.5a4.25 4.25 0 0 0-4.25-4.25h-8.5ZM17.5 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2ZM12 7a5 5 0 1 1 0 10 5 5 0 0 1 0-10Zm0 1.5A3.5 3.5 0 1 0 12 15.5 3.5 3.5 0 0 0 12 8.5Z" />
                  </svg>
                  <span>{t.about.link}</span>
                </a>
                <a
                  href="tel:+358442378086"
                  className="about-phone-link"
                  aria-label="Phone number"
                >
                  <svg viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M17 2H7c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-5 18c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm5-3H7V4h10v13z" fill="currentColor"/>
                  </svg>
                  <span>+358 044 237 8086</span>
                </a>
              </div>
            </div>
            <div className="about-image">
              <div className="about-image-placeholder">
                <img src="/images/ari-photo.jpg" alt="Founder Ari" className="about-founder-image" />
              </div>
              <div className="about-image-arc"></div>
            </div>
          </div>
        </div>
      </section>

      {/* Stories Section */}
      <section id="stories" className="stories">
        <div className="container">
          <h2 className="section-title">{t.stories.title}</h2>
          <div className="stories-grid">
            {stories.map((story, index) => (
              <div key={index} className="story-card">
                <div className="story-carousel">
                  <img
                    src={storyImages[index][storySlides[index]]}
                    alt={story.title}
                    className="story-image"
                  />
                  <button
                    className="story-carousel-btn prev"
                    onClick={() => changeStorySlide(index, -1)}
                    aria-label={`Previous image for ${story.title}`}
                  >
                    &#10094;
                  </button>
                  <button
                    className="story-carousel-btn next"
                    onClick={() => changeStorySlide(index, 1)}
                    aria-label={`Next image for ${story.title}`}
                  >
                    &#10095;
                  </button>
                </div>
                <h3 className="story-title">{story.title}</h3>
                <p className="story-description">{story.description}</p>
                {t.stories.link && (
                  <a href="#stories" className="story-link">{t.stories.link}</a>
                )}
              </div>
            ))}
          </div>
          
        </div>
      </section>

      {/* Reviews Section */}
      <section id="reviews" className="reviews">
        <div className="container">
          <h2 className="section-title reviews-heading">{t.intro.reviewsTitle}</h2>
          <p className="reviews-lead">{t.intro.reviewsLead}</p>
          <div className="reviews-grid">
            <div className="review-carousel">
              <button
                className="review-carousel-btn prev"
                onClick={() => changeReviewSlide('first', -1)}
                aria-label="Previous review"
              >
                &#10094;
              </button>
              <article className="review-card" key={reviewSlides.first}>
                <span className="review-quote" aria-hidden="true">&ldquo;</span>
                <h4 className="review-name">{firstReviewTrack[reviewSlides.first].name}</h4>
                <p className="review-stars" aria-label="5 out of 5 stars">★★★★★</p>
                <p className="review-comment">{firstReviewTrack[reviewSlides.first].comment}</p>
              </article>
              <button
                className="review-carousel-btn next"
                onClick={() => changeReviewSlide('first', 1)}
                aria-label="Next review"
              >
                &#10095;
              </button>
            </div>
            <div className="review-carousel">
              <button
                className="review-carousel-btn prev"
                onClick={() => changeReviewSlide('second', -1)}
                aria-label="Previous review"
              >
                &#10094;
              </button>
              <article className="review-card" key={reviewSlides.second}>
                <span className="review-quote" aria-hidden="true">&ldquo;</span>
                <h4 className="review-name">{secondReviewTrack[reviewSlides.second].name}</h4>
                <p className="review-stars" aria-label="5 out of 5 stars">★★★★★</p>
                <p className="review-comment">{secondReviewTrack[reviewSlides.second].comment}</p>
              </article>
              <button
                className="review-carousel-btn next"
                onClick={() => changeReviewSlide('second', 1)}
                aria-label="Next review"
              >
                &#10095;
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-content">
          <div className="footer-address">
            <h3 className="footer-title">{t.footer.visit}</h3>
            <p className="footer-text">Mikkolantie 2 lh4, 33470 Ylöjärvi</p>
            <p className="footer-text">TMI Ari Parturi</p>
            <p className="footer-text">Y-tunnus: 3464311-9</p>
            <p className="footer-text">Puhelin: +358 044 237 8086</p>
          </div>
          <div className="footer-map">
            <iframe
              src={`https://www.google.com/maps?q=${encodeURIComponent('Mikkolantie 2 lh4, 33470 Ylöjärvi, Finland')}&t=&z=15&ie=UTF8&iwloc=&output=embed`}
              width="100%"
              height="300"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Ari Parturi&Kampaamo Location"
            ></iframe>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Ari Parturi&Kampaamo. {t.footer.rights}</p>
        </div>
      </footer>
    </div>
  );
}

export default App;
